import QualtricsFeedbackForm from "./QualtricsFeedbackForm";

export default QualtricsFeedbackForm;
